import { IataBinderDocumentsUpload } from '@/features/iata-binder/IataBinderDocumentsUpload';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/iata-binder/projects/$projectId/upload')(
    {
        component: IataBinderUploadPage,
    },
);

function IataBinderUploadPage() {
    const navigate = Route.useNavigate();
    const { projectId: _projectId } = Route.useParams();

    const handleBack = () => {
        navigate({
            to: '/iata-binder/projects/$projectId/page',
            params: { projectId: _projectId },
        });
    };

    return <IataBinderDocumentsUpload onBack={handleBack} />;
}
